import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PayableCityService {
  constructor(private _httpProvider : HttpProviderService) {}

  fetchCity(stateCode): Observable<any[]> {
    const requestPayload: HttpRequestPayload = {
      resource: "/city",
      queryParams: [
        {
          key: "countryCode",
          value: "US",
        },
        {
          key: "stateCode",
          value: stateCode,
        },
        {
          key: "lookup",
          value: "1",
        },
      ],
      method: "GET",
    };
    return this._httpProvider.invokeApi(requestPayload).pipe(
      map((res: IHttpSuccessPayload<any>) => res.body.Data),

      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    );
  }
}
